<template>
  <div :class="['input-container', {focused: isLabelCollapsed}]">
    <input
      v-on="$listeners"
      v-model="__modelValue"
      :id="inputId"
      :class="['code-input', inputClass, {has_error: invalid}]"
      :name="inputName"
      :maxlength="maxLength"
      pattern="[0-9]*"
      :type="inputType"
      inputmode="numeric"
      @focus="handleInputFocus"
      @blur="handleInputBlur"
    />

    <label :for="inputId" class="placeholder-label">{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: 'BaseDigitFormInput',
  emits: ['update:modelValue'],
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    inputId: {
      type: String,
      default: 'inputPin'
    },
    inputName: {
      type: String,
      default: 'mobile'
    },
    inputType: {
      type: String,
      default: 'tel'
    },
    invalid: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: null
    },
    inputClass: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isInputFocused: false
    }
  },
  computed: {
    __modelValue: {
      get () {
        return this.modelValue
      },
      set (value) {
        this.$emit('update:modelValue', value)
      }
    },
    isLabelCollapsed () {
      return !!this.__modelValue || this.isInputFocused
    }
  },
  methods: {
    handleInputFocus () {
      this.isInputFocused = true
    },
    handleInputBlur () {
      this.isInputFocused = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/formInput/BaseDigitFormInput.vue